
@switch (matType) {
  @case ('simple') {
    <button
      mat-button
      [type]="type"
      [color]="color"
      [disabled]="disabled"
      [attr.tabIndex]="disabled ? -1 : null"
      [ngClass]="buttonClass"
      (click)="onClick.emit($event);"
      [disableRipple]="disableRipple"
      [ngStyle]="style"
      [matTooltip]="tooltip"
      [matTooltipDisabled]="!tooltip"
      [attr.aria-label]="ariaLabel || tooltip"
      [attr.aria-haspopup]="ariaHaspopup"
      [attr.aria-expanded]="ariaExpanded"
      [attr.aria-controls]="ariaControls"
      [attr.role]="role"
      [attr.cdkFocusInitial]="focusInitial ? '' : null"
      >
      @if (icon) {
        <!-- Decorative: the button's text / ariaLabel is the accessible name; hiding the icon prevents SR duplication. -->
        <ng-icon [class]="iconClass" [name]="icon" aria-hidden="true"></ng-icon>
      }
      @if (!!text) {
        <span [class]="textClass">{{ text }}</span>
      }
    </button>
  }
  @case ('raised') {
    <button
      mat-raised-button
      [type]="type"
      [color]="color"
      [disabled]="disabled"
      [attr.tabIndex]="disabled ? -1 : null"
      [ngClass]="buttonClass"
      (click)="onClick.emit($event)"
      [disableRipple]="disableRipple"
      [ngStyle]="style"
      [matTooltip]="tooltip"
      [matTooltipDisabled]="!tooltip"
      [attr.aria-label]="ariaLabel || tooltip"
      [attr.aria-haspopup]="ariaHaspopup"
      [attr.aria-expanded]="ariaExpanded"
      [attr.aria-controls]="ariaControls"
      [attr.role]="role"
      [attr.cdkFocusInitial]="focusInitial ? '' : null"
      >
      @if (icon) {
        <ng-icon [class]="iconClass" [name]="icon" aria-hidden="true"></ng-icon>
      }
      @if (!!text) {
        <span [class]="textClass">{{ text }}</span>
      }
    </button>
  }
  @case ('stroked') {
    <button
      mat-stroked-button
      [type]="type"
      [color]="color"
      [disabled]="disabled"
      [attr.tabIndex]="disabled ? -1 : null"
      [class]="buttonClass"
      (click)="onClick.emit($event)"
      [disableRipple]="disableRipple"
      [ngStyle]="style"
      [matTooltip]="tooltip"
      [matTooltipDisabled]="!tooltip"
      [attr.aria-label]="ariaLabel || tooltip"
      [attr.aria-haspopup]="ariaHaspopup"
      [attr.aria-expanded]="ariaExpanded"
      [attr.aria-controls]="ariaControls"
      [attr.role]="role"
      [attr.cdkFocusInitial]="focusInitial ? '' : null"
      >
      @if (icon) {
        <ng-icon [class]="iconClass" [name]="icon" aria-hidden="true"></ng-icon>
      }
      @if (!!text) {
        <span [class]="textClass">{{ text }}</span>
      }
    </button>
  }
  @case ('icon') {
    <button
      mat-icon-button
      [type]="type"
      [color]="color"
      [disabled]="disabled"
      [attr.tabIndex]="disabled ? -1 : null"
      [class]="buttonClass"
      (click)="onClick.emit($event)"
      [disableRipple]="disableRipple"
      [ngStyle]="style"
      [matTooltip]="tooltip"
      [matTooltipDisabled]="!tooltip"
      [attr.aria-label]="ariaLabel || tooltip"
      [attr.aria-haspopup]="ariaHaspopup"
      [attr.aria-expanded]="ariaExpanded"
      [attr.aria-controls]="ariaControls"
      [attr.role]="role"
      [attr.cdkFocusInitial]="focusInitial ? '' : null"
      >
      @if (icon) {
        <ng-icon [class]="iconClass" [name]="icon" aria-hidden="true"></ng-icon>
      }
      @if (!!text) {
        <span [class]="textClass">{{ text }}</span>
      }
    </button>
  }
  @case ('fab') {
    <button
      mat-fab
      [type]="type"
      [color]="color"
      [disabled]="disabled"
      [attr.tabIndex]="disabled ? -1 : null"
      [class]="buttonClass"
      (click)="onClick.emit($event)"
      [disableRipple]="disableRipple"
      [ngStyle]="style"
      [matTooltip]="tooltip"
      [matTooltipDisabled]="!tooltip"
      [attr.aria-label]="ariaLabel || tooltip"
      [attr.aria-haspopup]="ariaHaspopup"
      [attr.aria-expanded]="ariaExpanded"
      [attr.aria-controls]="ariaControls"
      [attr.role]="role"
      >
      @if (icon) {
        <ng-icon [class]="iconClass" [name]="icon" aria-hidden="true"></ng-icon>
      }
      @if (!!text) {
        <span [class]="textClass">{{ text }}</span>
      }
    </button>
  }
  @case ('mini-fab') {
    <button
      mat-mini-fab
      [type]="type"
      [color]="color"
      [disabled]="disabled"
      [attr.tabIndex]="disabled ? -1 : null"
      [class]="buttonClass"
      (click)="onClick.emit($event)"
      [disableRipple]="disableRipple"
      [ngStyle]="style"
      [matTooltip]="tooltip"
      [matTooltipDisabled]="!tooltip"
      [attr.aria-label]="ariaLabel || tooltip"
      [attr.aria-haspopup]="ariaHaspopup"
      [attr.aria-expanded]="ariaExpanded"
      [attr.aria-controls]="ariaControls"
      [attr.role]="role"
      >
      @if (icon) {
        <ng-icon [class]="iconClass" [name]="icon" aria-hidden="true"></ng-icon>
      }
      @if (!!text) {
        <span [class]="textClass">{{ text }}</span>
      }
    </button>
  }
}
